const HOST = (env) => ({
  tvb: "https://homepage.tvb-sz.com",
  qa: "https://qa-www.tvb.com",
  prod: "https://www.tvb.com"
})[env];
const USER_SYSTEM_HOST = (env) => ({ tvb: "https://qa-id.tvb.com", qa: "https://qa-id.tvb.com", prod: "https://id.tvb.com" })[env];
const USER_REGISTRATION = (env) => `${USER_SYSTEM_HOST(env || "prod")}/tc/registration`;
const USER_MEMBERZONE = (env) => `${USER_SYSTEM_HOST(env || "prod")}/tc/memberzone`;
const USER_LOGIN = (env) => `${USER_SYSTEM_HOST(env || "prod")}/tc/login?appType=tvbcom&destUrl=${encodeURIComponent(
  location.href
)}`;
const USER_LOGOUT = (env) => `${USER_SYSTEM_HOST(env || "prod")}/tc/logout?destUrl=${encodeURIComponent(location.href)}`;
const API_BASE = (env) => ({
  tvb: "https://programme.tvb-sz.com/api",
  qa: "https://qa-www.tvb.com/api",
  prod: "https://www.tvb.com/api"
})[env];
const GTM_ID = (env) => env === "qa" ? "GTM-TG5P3K9" : "GTM-MGK95RM";
const PUBLIC_URL = (env) => ({
  tvb: "https://homepage.tvb-sz.com",
  qa: "https://qa-www.tvb.com",
  prod: "https://www.tvb.com"
})[env];
const WEBSITE = [
  "https://qa-www.tvb.com",
  "https://www.tvb.com",
  "https://homepage-4e5c5tu4dq-df.a.run.app",
  "https://homepage-le5cl4f3uq-df.a.run.app"
];

export { API_BASE, GTM_ID, HOST, PUBLIC_URL, USER_LOGIN, USER_LOGOUT, USER_MEMBERZONE, USER_REGISTRATION, USER_SYSTEM_HOST, WEBSITE };
//# sourceMappingURL=getConstant.mjs.map
